import { registerSvelte, globToComponents } from "../lib/registerSvelte.svelte"
import "../lib/devtools"

const svelteImports = globToComponents(import.meta.glob("../components/*.svelte", {eager: false}))
registerSvelte(svelteImports)

// Example: Load Rails libraries in Vite.
//
import * as Turbo from '@hotwired/turbo'
Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', {eager: true})
